import * as React from "react";
import { Component, Fragment, ReactElement } from "react";
import {connect} from "react-redux";
import {IRootState} from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import Table, { TableColumn } from "../Table";
import TableCell from "../TableCell";
import { CustomerError } from "../../models/MailroomProcessorItem";
import Actions from "../../redux/Actions";
import {SchoolDataReport} from "../../models/SchoolDataReport";
import { MessageBarType } from "office-ui-fabric-react";
import HelpBox from "./admin/HelpBox";
import SchoolMenu from "../SchoolMenu";
import SchoolPageTitle from "../SchoolPageTitle";

interface SchoolDataReportPageProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
}

interface SchoolDataReportPageState {
    schoolDataReport?: SchoolDataReport;
    isLoading: boolean;
}

class SchoolDataReportPage extends Component<SchoolDataReportPageProps & DispatchProps,SchoolDataReportPageState> {
    
    constructor(props: SchoolDataReportPageProps & DispatchProps) {
        super(props);

        this.state = {
            isLoading: false,
        };
    }

    async componentDidMount() {
        if (this.props.tenantId && this.props.schoolCode) {
            await this.loadReport();
        }
    }

    async componentDidUpdate(prevProps: Readonly<SchoolDataReportPageProps & DispatchProps>, prevState: any): Promise<void> {
        if (this.props.tenantId !== prevProps.tenantId && this.props.schoolCode != prevProps.schoolCode) {
            await this.loadReport();
        }
    }


    private async loadReport() {

        this.setState({
            isLoading: true
        });

        try {
            const schoolDataReport = await this.props.apiService.getSchoolDataReport(this.props.tenantId, this.props.schoolCode);

            this.setState({schoolDataReport});
        }
        catch (e) {
            console.log(e);
            this.props.dispatch(Actions.showMessageBar(`Could not load user report: ${e.message}`, MessageBarType.error));
        }

        this.setState({
            isLoading: false
        });
    }

    private profileColumns: TableColumn[] = [
        {
            title: "SDS Flow",
            propertyPath: "profileReport.sdsProfileName",
            flex: 2
        },
        {
            title: "Data Last Received",
            propertyPath: "schoolReport.lastDataUpload",
            type: "date",
            flex: 2
        },
        {
            title: "Last Sync",
            propertyPath: "profileReport.lastSdsUpload",
            flex: 2,
            type: "date"
        },
    ];

    private errorColumns: TableColumn[] = [
        {
            title: "Name",
            propertyPath: "name",
            extraDetail: "UserName",
            flex: 1
        },
        {
            title: "Error",
            propertyPath: "message",
            extraDetail: "Help",
            flex: 2
        }
    ];

    private cellForErrorColumn = (item: CustomerError, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined => {
        switch (column.propertyPath) {
            case "name":
                return (
                    <TableCell flex={column.flex} key={columnIndex}>
                        <span>{item.name}</span>
                        <span><div className="cdb-table__extra-detail">{item.username}</div></span>
                    </TableCell>
                );

            case "message":
                return (
                    <TableCell flex={column.flex} key={columnIndex}>
                        <span>{item.message}</span>
                        <span><div className="cdb-table__extra-detail">{item.help}</div></span>
                    </TableCell>
                ); 
                
            default:
                return undefined;
        }
    };
    
    public render(): JSX.Element {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Sync Status" reverse={true} />

                <SchoolMenu prefix="School Data" />

                <div className={"cdb-admin-content cdb-admin-content--column"}>
                    <HelpBox Icon={"CloudImportExport"} TitleText={"Sync Status"} HelpBoxText={"If you need help resolving these issues please contact: support@clouddesignbox.co.uk"} />
    
                    <Table
    
                        title={"SDS Sync Status"}
                        items={this.state.schoolDataReport ? [this.state.schoolDataReport] : []}
                        columns={this.profileColumns}
                        emptyMessage="Could not determine sync status"
                        loading={this.state.isLoading}
                    />
    
                    <Table
                        className={"cdb-table--enable-hover"}
                        title={"User Errors"}
                        items={this.state.schoolDataReport ? this.state.schoolDataReport.schoolReport.userErrors : []}
                        columns={this.errorColumns}
                        cellForColumn={this.cellForErrorColumn}
                        emptyMessage="No user errors found"
                        loading={this.state.isLoading}
                    />
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: any): SchoolDataReportPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService,
        };

    }
)(SchoolDataReportPage)